import React from 'react';
import './projects.scss';


import DocumentsTab from '../documents/projectDocs.js';

const AREA_PROJECT = 3;

export default function ProjectDocumentsTab(props) {

    return (
        <div>
            
            <DocumentsTab projectId = {props.projectId} area = {AREA_PROJECT}></DocumentsTab>

        </div>
    
)};